"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Fri Aug 24 2018
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * FlagsBindingConverter
 *
 * @author RV
 */


var PriceClassificationsBindingConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(PriceClassificationsBindingConverter, _DataObjectConverter_);

  function PriceClassificationsBindingConverter() {
    _classCallCheck(this, PriceClassificationsBindingConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PriceClassificationsBindingConverter).apply(this, arguments));
  }

  return PriceClassificationsBindingConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.PriceClassificationsBindingConverter = PriceClassificationsBindingConverter;